import AssignmentIcon from '@mui/icons-material/Assignment';
import { AgentRoleKeys } from 'gmd-utilities-package';

export type UserReportType = 'USERREPORT';
export type ReceiptReportType = 'RECEIPTREPORT';

type ReportKind = UserReportType | ReceiptReportType;

export type ReportItemType = {
  reportId: string;
  reportContainer: string;
  name: string;
  sub: string;
  icon: JSX.Element;
  roles: string[];
  description: string;
  reportCategory: ReportKind;
};

export const CustomReports: ReportItemType[] = [
  {
    reportId: 'collections',
    reportContainer: 'CollectionsReport',
    name: 'Collections/Commissions Report',
    sub: 'Collections Data',
    icon: <AssignmentIcon />,
    roles: [],
    description: ' — Breakdown of all collections and agent commissions... ',
    reportCategory: 'USERREPORT',
  },
  {
    reportId: 'financialusage',
    reportContainer: 'UsageReport',
    name: 'Usage Report',
    sub: 'Collections Data',
    icon: <AssignmentIcon />,
    roles: [AgentRoleKeys.super],
    description: ' — Shows currency usage across clients... ',
    reportCategory: 'USERREPORT',
  },
  {
    reportId: 'tenantledger',
    reportContainer: 'BalanceLedgerReport',
    name: 'Client Balance Ledger',
    sub: 'Client Ledger',
    icon: <AssignmentIcon />,
    roles: [AgentRoleKeys.super],
    description: ' — Shows ledger activity for client... ',
    reportCategory: 'USERREPORT',
  },
  {
    reportId: 'momobasic',
    reportContainer: 'ReceiptContainer',
    name: 'Generic mobile money receipt',
    sub: 'Receipt Data',
    icon: <AssignmentIcon />,
    roles: [],
    description: ' — Breakdown of all collections and agent commissions... ',
    reportCategory: 'RECEIPTREPORT',
  },
];
